import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

import { OrderDeliveryInfo } from '@/models';
import { Routes } from '@/router';
import { FeedbackResponse } from '@/models/feedback';

const REFRESH_ORDER_POLL_MS = 60 * 1000;
const MAX_ORDER_POLL_TIME_MS = 3 * 60 * 60 * 1000;

@Component({
  name: 'CmgBanner',
})
export default class CmgBanner extends Vue {
  lastCheckedTime: moment.Moment = moment();
  delivery: OrderDeliveryInfo | null = null;

  @Prop({ default: false, type: Boolean })
  blur!: boolean;

  get orderStatusBarVisible(): boolean {
    if (this.$route.name === Routes.Checkout || this.$route.name === Routes.OrderConfirmation) {
      return false;
    }

    if (!this.order || !this.$appStore.state.customer.jwt) {
      return false;
    }

    return !this.isExpired;
  }

  get sessionExpiredBarVisible(): boolean {
    return this.$appStore.state.ui.showSessionExpiredBanner;
  }

  // This may have odd side affects for locations that border time zones
  get isExpired(): boolean {
    if (this.isDelivery) {
      return !!this.delivery && moment(this.delivery.quotedDeliveryTime || '').add(3, 'hour') < this.lastCheckedTime;
    }

    return !!this.order && moment(this.order.order.pickupDateTimeLocal || '').add(3, 'hour') < this.lastCheckedTime;
  }

  get isDelivery(): boolean {
    return !!this.order && !!this.order.order.delivery;
  }

  get order() {
    return this.$appStore.state.order.lastOrder.order;
  }

  get feedback(): FeedbackResponse | null {
    return this.$appStore.state.order.feedback;
  }
}
